<template>
	<div class="bg">
        <div class="page1">
            <!-- <div class="item">
                <div class="backbtn" @click="goback()">
                    <i class="su-icon-zuojiantou"></i>
                    <span>返回</span>
                </div>
            </div> -->
            <div class="content">
                <p class="title">绑定邮箱</p>
                <p class="input-title">邮箱别名</p>
                <sw-input placeholder="如：私人邮箱，部门邮箱，学院邮箱等" v-model="emailName"  maxlength="6" @blur="checkinput()"></sw-input>
                <p class="input-title">邮箱地址</p>
                <sw-input placeholder="如：xx@mail.nwpu.edu.cn/xx@nwpu.edu.cn" v-model="emailAccount" @blur="checkinput()">
                </sw-input>
                <p class="input-title">邮箱密码</p>
                <sw-input placeholder="请输入邮箱密码" v-model="password" show-password @blur="checkinput()"></sw-input>
                <p class="input-title switchbtn">设为主邮箱</p>
                <sw-switch v-model="mainEmail" active-color="#ED663F" inactive-color="#E6EBEE" :isLabel="false"></sw-switch>
                <sw-button round :class="{active:activeBtn}" @click="register()">绑定</sw-button>
            </div>
        </div>
        <transition name="flash">
            <sw-tip icon="su-icon-error" v-if="show">
                <div slot="text">
                    <div>{{this.message}}</div>
                </div>
            </sw-tip>
        </transition>
        <transition name="flash">
            <sw-tip  v-if="show2" :show-icon="false">
                <div slot="text">
                    <div>{{this.message}}</div>
                </div>
            </sw-tip>
        </transition>
    </div>
</template>

<script>
    import { saveEmailBox } from '@/api/xigongda.js';
    import { setToken } from "@/utils/auth";
	export default {
		components: {

		},
		data() {
            return {
                emailName:'',
                emailAccount:'',
				password:'',
                activeBtn:false,
                message:'',
                show:false,
                show2:false,
                mainEmail:true
			}
		},
        created(){
            this.mydecodeTicket();
        },
		methods: {
            mydecodeTicket(){
                console.log(location.href);
                if (location.href.indexOf("token=") != -1) {
                    let url = location.href;
                    let token = url.split('=')[1];
                    setToken(token);
                }
            },
            goback(){
                
            },
            checkinput(){
				if( this.emailname != '' && this.emailAccount != '' && this.Password != ''){
					this.activeBtn = true;
				}else{
					this.activeBtn = false;
				}
			},
            showTost(msg){
                if(!this.show){
                    this.show = !this.show;
                    this.message = msg;
                    setTimeout(() => {
                        this.show = !this.show;
                    } ,2000)
                }
            },
            showTost2(msg){
                if(!this.show2){
                    this.show2 = !this.show2;
                    this.message = msg;
                    setTimeout(() => {
                        this.show2 = !this.show2;
                    } ,2000)
                }
            },
            /* 注册按钮 */
			register(){
				if( !this.activeBtn ){
					return 
				}else{
                    let email = {
                        "emailAddress": this.emailAccount,
                        "emailName": this.emailName,
                        "mainEmail": this.mainEmail,
                        "password": this.password,
                        "showOnIndex": true
                    }
                    saveEmailBox(email).then(res => {
                        console.log(res)
                        if(res.code == 0){//注册成功切换页面
                            this.goback()
                        }else{
                            this.showTost2(res.message)
                        }
				    })
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
    .bg{
        width: 100%;
        height: 100%;
        background-color: #FFFFFF;
        .page1{
            width: inherit;
            height: inherit;
            .item{
                width: 100%;
                height:48px;
                line-height:48px;
            }
            .backbtn{
                width: 100px;
                height: 48px;
                padding-left: 10px;
                font-size: 16px;
                .su-icon-zuojiantou:before{
                    color: #1F2021;
                    font-weight: bold;
                }
                span{
                    padding-left: 5px;
                }
            }
            .content{
                width: 100%;
                height: auto;
                padding: 0 27px;
                color: #3A3C40;
                font-family: PingFangSC-Medium, PingFang SC;
                .title{
                    height: 30px;
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 32px;
                    margin: 27px 0px 50px;
                }
                .sub-title{
                    height: 15px;
                    font-size: 15px;
                    line-height: 15px;
                    font-weight: 400;
                    margin-bottom: 45px;
                }
                .input-title{
                    font-size: 17px;
                    font-weight: 400;
                    color: rgba(58, 60, 64, 1);
                    line-height: 17px;
                    margin-top: 22px;
                }
                .sw-input{
                    border-bottom: 1px solid #D9DCE0 ;
                    font-size: 16px;
                }
                .tpis{
                    width: 100%;
                    min-height: 50px;
                    margin: 0 auto;
                    background-color: #F1F3F6;
                    margin-top: 25px;
                    font-size: 14px;
                    line-height: 20px;
                    padding: 6px 16px;
                }
                .sw-button{
                    width: 100%;
                    height: 44px;
                    background-color: rgba(237, 102, 63, 0.4);
                    border: unset;
                    border-radius: 22px;
                    justify-content: center;
                    align-items: center;
                    margin-top: 45px;
                    color: #fff;
                }
                .sw-button.active{
                    background-color: rgba(237, 102, 63, 1);
                }
                .sw-button:focus, .sw-button:hover{
                    background-color: rgba(237, 102, 63, 0.4);
                    border:unset;
                }
                .sw-button.active:focus, .sw-button.active:hover{
                    background-color: rgba(237, 102, 63, 1);
                }
                /deep/ .el-input-group__append{
                    border: unset;
                    background-color: #ffffff;
                    padding: 0 10px;
                }
                .switchbtn{
                    width: calc(100% - 40px);
                    display: inline-block;
                }
            }
        }
        .page2{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .success-pic{
                width: 165px;
                height: 165px;
                margin: 110px 0 11px;
            }
            .success-text{
                height: 18px;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1F2021;
                line-height: 18px;
            }
            .sw-button{
                width: 76%;
                height: 44px;
                background-color: #F1F3F6;
                border-radius: 22px;
                justify-content: center;
                align-items: center;
                margin-top: 45px;
                border:unset;
                color: #3A3C40;
            }
            
            .sw-button:focus, .sw-button:hover{
                background-color: #F1F3F6;
                border:unset;
            }
        }
        .sw-tip{
            width: 185px;
            min-height: 113px;
            position: absolute;
            margin: 70% auto;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            border-radius: 10px;
            border-color: rgba(0, 0, 0, 0.6);
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            /deep/ .sw-tip_icon{
                margin-right:0px;
            }
             /deep/ .su-icon-error:before{
                    color: #fff;
                    font-size: 30px;
                }
            /deep/ .sw-tip_text{
                color: #FFF;
                margin-right:0px;
                font-size: 15px;
                flex: 0;
            }
        }
    }
    /deep/ .el-input__inner{
        border:unset!important;
        padding-left: 0px;
        margin: 10px 0;
    }

    /deep/ .su-icon-hide:before{
            content: "\e7a7"!important;
        }
    /deep/ .su-icon-display:before{
            content: "\e7a3"!important;
        }

    .flash-enter-active, .flash-leave-active {
        transition: opacity 0.8s;
    }
    .flash-enter, .flash-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }









	.emailBtn {
		width: 650rpx;
		height: 88rpx;
		background-color: rgba(237, 102, 63, 0.4);
		border-radius: 44rpx;
		justify-content: center;
		align-items: center;
		margin-top: 90rpx;
	}
	.emailBtn.active{
		background-color: rgba(237, 102, 63, 1);
	}
	.gobackBtn {
		width: 650rpx;
		height: 88rpx;
		background-color: #F1F3F6;
		border-radius: 44rpx;
		justify-content: center;
		align-items: center;
		margin-top: 90rpx;
	}
	.success-pic{
		width: 300rpx;
		height: 300rpx;
		margin: 200rpx 0 20rpx;
	}
	.success-text{
		height: 36rpx;
		font-size: 36rpx;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #1F2021;
		line-height: 36rpx;
	}
	.succnext{
		font-size: 34rpx;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		line-height: 34rpx;
		color: rgba(58, 60, 64, 1);
	}
	.warn{
		background: #F1F3F6;
		padding: 12rpx 30rpx;
		font-size: 26rpx;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6F737A;
		line-height: 38rpx;
		margin-top: 50rpx;
	}
</style>